// // Alert legacy:
// //   - In the future, we should have account as a folder with 3 separate sub routes
// //   - They should also show 403 if the user is not logged in

import { Account } from 'pages/Account'

const AccountPage = () => <Account />

export default AccountPage
